<template>
  <div class="state-block state-empty">
    <strong>{{ title || $store.getters.t('noData') }}</strong>
    <span v-if="message">{{ message }}</span>
    <button v-if="actionText" type="button" class="button button-dark" @click="$emit('action')">{{ actionText }}</button>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: { title: String, message: String, actionText: String }
}
</script>
